import { connect } from 'react-redux';
import * as _ from 'lodash';
import { getSandboxJurisdictionCodes } from '../../jurisdiction/redux/selectors';

/*
  Says whether something belongs to a sandbox, by the code of its jurisdiction, to what it renders: {isSandbox => ...}. What is in a
  sandbox is read-only: its alerts cannot be dismissed, delegated, given a note or exported.
*/
export const SandboxCheck = connect(state => ({
    sandboxCodes: getSandboxJurisdictionCodes(state)
}))(({ sandboxCodes, jurisdiction, children }) =>
    children(!!jurisdiction && _.includes(sandboxCodes, jurisdiction))
);
